import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import GenericDetails from '../../common/GenericDetails';
import ChemicalProductDetailsForm from './ChemicalProductDetailsForm';
import getChemicalProductDetailsFormSchema from '../../../formSchemas/ChemicalProductDetailsFormSchema';
import { chemicalProductsActions } from '../../../behavior/chemicalProducts/index';
import { Mode, entityType } from '../../../constants';
import { manipulateValuesBeforeSubmission } from '../../../utils';
import useUser from '@behavior/init/getUserV2';

const ChemicalProductDetailsFormContainer = ({
  save,
  mode,
  isLoading,
  initialData,
  getInitialData,
  chemicalProduct,
  getChemicalProduct,
  deleteChemicalProduct,
  id,
  processedNotificationBody,
  recipients,
  i18n,
}) => {
  const { user } = useUser();

  useEffect(() => {
    getInitialData(mode == Mode.CREATE || mode == Mode.CLONE, mode == Mode.CLONE);
    if (id) getChemicalProduct(id, mode == Mode.CLONE);
  }, []);

  let initialValues = chemicalProduct ? { chemicalProduct: chemicalProduct } : null;
  const submitHandle = (values, actions) => {
    save(
      manipulateValuesBeforeSubmission(
        values,
        processedNotificationBody,
        recipients,
        user,
        i18n,
        false
      ),
      mode
    );
    actions.setSubmitting(false);
  };

  return (
    <GenericDetails
      initialValues={initialValues}
      validationSchema={getChemicalProductDetailsFormSchema()}
      validateOnChange={mode === Mode.CREATE || Mode.CLONE || Mode.EDIT}
      initialData={initialData}
      save={save}
      mode={mode}
      isLoading={isLoading}
      isHistory={false}
      id={id}
      deleteHandler={deleteChemicalProduct}
      entityTypeProp={entityType.product}
      updateUser={initialValues ? initialValues.chemicalProduct.updateUser : null}
      renderContainer={props => <ChemicalProductDetailsForm {...props} isHistory={false} />}
      submitHandle={submitHandle}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...state.chemicalProducts,
  mode: ownProps.match.params.mode,
  id: ownProps.match.params.id,
  processedNotificationBody: state.changesNotificationModal.processedChangesNotification,
  recipients: state.changesNotificationModal.recipients,
});

const mapDispatchToProps = dispatch => ({
  getInitialData: (isCreateMode, isCloneMode) =>
    dispatch(chemicalProductsActions.getInitialData(isCreateMode, isCloneMode)),
  getChemicalProduct: (id, isCloneMode) =>
    dispatch(chemicalProductsActions.getChemicalProduct(id, isCloneMode)),
  getNewChemicalProduct: () => dispatch(chemicalProductsActions.getNewChemicalProduct()),
  save: saveDto => dispatch(chemicalProductsActions.saveChemicalProduct(saveDto)),
  deleteChemicalProduct: id => dispatch(chemicalProductsActions.deleteChemicalProduct(id, true)),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ChemicalProductDetailsFormContainer);
